const subtitleMap = {
  'Buy 1 jar': 'Shipped every month. No commitment. Cancel anytime',
  'Buy 2, Get 1 Free': 'Shipped every 3 months. No commitment. Cancel anytime',
  'Buy 3, Get 2 Free': 'Shipped every 5 months. No commitment. Cancel anytime',
  'Buy 3 Jars': 'Shipped every 3 months. No commitment. Cancel anytime',
  'Buy 6 Jars': 'Shipped every 6 months. No commitment. Cancel anytime',
  '1 Month Supply': 'Shipped every month. No commitment. Cancel anytime',
  '3 Month Supply': 'Shipped every 3 months. No commitment. Cancel anytime',
  '6 Month Supply':'Shipped every 6 months. No commitment. Cancel anytime'
};

document.addEventListener('DOMContentLoaded', () => {
  const kachingBundlesBlock = document.querySelector('kaching-bundle');
  if (kachingBundlesBlock) {
    const observer = new MutationObserver((mutations) => {
      const hasNewElements = mutations.some(mutation => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          return Array.from(mutation.addedNodes).some(node => node.nodeType === Node.ELEMENT_NODE);
        }
        return false;
      });

      if (hasNewElements) {
        setTimeout(() => {
          syncSubtitle();
        }, 100);
      }
    });

    observer.observe(kachingBundlesBlock, {
      childList: true,        
      subtree: true,         
      attributes: false     
    });

    syncSubtitle();
  }
});

const syncSubtitle = () => {
  const selected = document.querySelector('.kaching-bundles__bar--selected');
  const subtitleEl = document.querySelector('.kaching-bundles__subscriptions__subtitle');

  if (!selected || !subtitleEl) return;

  const titleEl = selected.querySelector('.kaching-bundles__bar-title');
  if (!titleEl) return;

  const title = titleEl.textContent.trim();

  if (title) {
    const mappedSubtitle = subtitleMap[title];
    if (mappedSubtitle) {
      subtitleEl.textContent = mappedSubtitle;
    }
  }

  const sellingPlanInputs = document.querySelectorAll('.kaching-bundles input');

  sellingPlanInputs.forEach((input) => {
    input.addEventListener('change', () => {
      const title = input.closest('.kaching-bundles__bar').querySelector('.kaching-bundles__bar-title').textContent.trim();;

      const mappedSubtitle = subtitleMap[title];
    if (mappedSubtitle) {
      subtitleEl.textContent = mappedSubtitle;
    }
    });
  });
};